import React from 'react';

import { useUserRightsIn } from 'hooks/useUserRightsIn';
import { useUserTypeIn } from 'hooks/useUserTypeIn';

import { APIUserRight, APIUserType } from 'types/api';

export type CanAccessProps = {
  allowedUserType?: APIUserType | APIUserType[] | undefined;
  forbiddenUserType?: APIUserType | APIUserType[] | undefined;
  allowedFor?: APIUserRight | APIUserRight[];
  forbiddenFor?: APIUserRight | APIUserRight[];
  childProps?: Record<string, any>;
  children?: any;
  fallback?: React.ReactNode | React.ReactNode[] | null;
};

export const CanAccess: React.FC<CanAccessProps> = ({
  allowedUserType,
  forbiddenUserType,
  allowedFor,
  forbiddenFor,
  childProps,
  children,
  fallback,
}) => {
  const userRights = useUserRightsIn();
  const userTypeIn = useUserTypeIn();

  const canAccess = [
    [forbiddenFor, forbiddenFor && !userRights(forbiddenFor)],
    [forbiddenUserType, forbiddenUserType && !userTypeIn(forbiddenUserType)],
    [allowedUserType, allowedUserType && userTypeIn(allowedUserType)],
    [allowedFor, allowedFor && userRights(allowedFor)],
  ].every(([condition, check]) => !condition || check);

  if (canAccess) {
    return children;
  } else if (childProps) {
    return (
      <>
        {React.Children.map(children, child =>
          React.cloneElement(child, childProps),
        )}
      </>
    );
  }

  return fallback || null;
};
